/**
 * Decide whether an attendance-roster payload may replace the name list
 * for the department pill that is on screen.
 *
 * A department switch fires overlapping fetches. A late response from the
 * previous pill still contains rows, but none of them belong to the
 * department now selected. Applying it runs the client department filter
 * down to nobody and the left panel stays blank until a full refresh
 * (which has no in-flight request to lose the race).
 *
 * An empty payload is a real empty department, not a stale one.
 * "All departments" (no ids) accepts any payload.
 *
 * @param {Array|null|undefined} records
 * @param {string[]} departmentIds
 * @returns {boolean}
 */
export function rosterPayloadBelongsToSelection(records, departmentIds) {
  const ids = (Array.isArray(departmentIds) ? departmentIds : [])
    .filter((id) => id && id !== 'all');
  if (ids.length === 0) return true;
  if (!Array.isArray(records) || records.length === 0) return true;
  return records.some((rec) => ids.includes(rec?.department_id));
}
